module.exports = __webpack_public_path__ + "static/media/material_icon_done.dba357bf.svg";


//////////////////
// WEBPACK FOOTER
// ./client/modules/ui/assets/material_icon_done.svg
// module id = 1248
// module chunks = 0